import {FacetsState} from "../../models/FacetsState"
import {Filters} from "../../models/Filter"

export const getOpenFiltersFromFacets = (facets: FacetsState, filters: Filters): Filters => {
    const updatedFilters = {...filters}
    const setOfOpenFilters = new Set()
    Object.keys(facets).forEach(key => {
        if (facets[key].s) setOfOpenFilters.add(key.split(":")[0])
    })
    Object.keys(filters).forEach(filterName => {
        if (setOfOpenFilters.has(filterName)) {
            updatedFilters[filterName] = {...updatedFilters[filterName], isFilterOpen: true}
        }
    })
    return updatedFilters
}

export default getOpenFiltersFromFacets
